import { render, staticRenderFns } from "./MediaBox.vue?vue&type=template&id=1c7c6e5c&scoped=true&"
import script from "./MediaBox.vue?vue&type=script&lang=js&"
export * from "./MediaBox.vue?vue&type=script&lang=js&"
import style0 from "./MediaBox.vue?vue&type=style&index=0&id=1c7c6e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7c6e5c",
  null
  
)

export default component.exports